export default "__VITE_ASSET__DgTaDdt3__"